import { render } from "./MobileRecordList.vue?vue&type=template&id=39c25695&scoped=true"
import script from "./MobileRecordList.vue?vue&type=script&lang=js"
export * from "./MobileRecordList.vue?vue&type=script&lang=js"

import "./MobileRecordList.vue?vue&type=style&index=0&id=39c25695&scoped=true&lang=css"

import exportComponent from "/Volumes/directory/IdeaProjects/Macau-Double-Color-Ball/Macau-Double-Color-Ball_Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c25695"]])

export default __exports__